import { ResourceModel } from './resource.model';
import { ResourceType } from '../../helpers/Const';

export class FolderModel extends ResourceModel {
    constructor(init?: Partial<FolderModel>) {
        super();
        Object.assign(this, init);
        this.type = ResourceType.FOLDER;
    }
}
